import { surChargeTypeDropdownOption, uomDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { StandardProposalConstant, standardProposalIsRequiredFieldList, standardProposalTierRequiredFieldList } from "presentation/constant/StandardProposal/StandardProposalConstant";
import { useStandardProposalDetailVM } from "presentation/hook/StandardProposal/useStandardProposalDetailVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { StandardProposalDetailModel } from "presentation/model/StandardProposal/StandardProposalDetailModel";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { memo, useCallback, useMemo } from "react";
import { FieldType, IconButton, IFieldValue } from "veronica-ui-component/dist/component/core";
import { SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";


const AddTariffItemIsEditPanel = ({ standardProposalDtlState }: { standardProposalDtlState: StandardProposalDetailModel }) => {
    //const [standardProposalDtlState] = useStandardProposalDetailTracked();
    const standardProposalDtlVM = useStandardProposalDetailVM();
    const messageBarVM = useMessageBarVM();
    const STANDARD_PROPOSAL_CONSTANT = StandardProposalConstant.Table;
    const { currentSelectItem, currentTariffItemTier, currentTariffItemIs, isAddIs, isAddTier, isEditIs, isEditTier } = standardProposalDtlState;
    const currentTier = currentTariffItemTier;
    const currentIs = currentTariffItemIs;
    const { isSaveClicked, allFormState } = standardProposalDtlState.detailState;


    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        standardProposalDtlVM.onTierFieldChange(fieldName, fieldValue);
    }, [standardProposalDtlVM]);

    const onIsNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        standardProposalDtlVM.onIsFieldChange(fieldName, fieldValue);
    }, [standardProposalDtlVM]);

    const handleCancel = useCallback(() => {
        standardProposalDtlVM.cancelAdd();
    }, [standardProposalDtlVM]);

    const handleSave = useCallback(async () => {
        if (isAddIs || isEditIs) {
            if (!currentTariffItemIs.shiftCode) {
                messageBarVM.showError("Shift Code is mandatory.");
                return;
            }
            if (currentTariffItemIs.percentage === null) {
                messageBarVM.showError("Surcharge % is mandatory.");
                return;
            }
        }
        if (isAddTier || isEditTier) {
            // if (currentTariffItemTier.minimum === null) {
            //     messageBarVM.showError("MINIMUM RATE is mandatory.");
            //     return;
            // }
            // if (currentTariffItemTier.rate === null) {
            //     messageBarVM.showError("RATE is mandatory.");
            //     return;
            // }
            // if (!currentTariffItemTier.uom) {
            //     messageBarVM.showError("UOM is mandatory.");
            //     return;
            // }
            // if (!currentTariffItemTier.forevery) {
            //     messageBarVM.showError("FOR_EVERY is mandatory.");
            //     return;
            // }
            // if (!currentTariffItemTier.cycle) {
            //     messageBarVM.showError("CYCLE is mandatory.");
            //     return;
            // }
            if (Number(currentTariffItemTier.minimum) > Number(currentTariffItemTier.rate)) {
                messageBarVM.showError("The Minimum should not be larger than Rate.");
                return;
            }
            if (currentSelectItem.stdIsList && currentSelectItem.stdIsList.length > 0 && currentSelectItem.tierList && currentSelectItem.tierList.length === 1) {
                messageBarVM.showError("Intensive surcharge does not support multiple charge tier.");
                return;
            }
            if ((!currentTariffItemTier.surcharge && currentTariffItemTier.surchargeType)
                || (currentTariffItemTier.surcharge && !currentTariffItemTier.surchargeType)) {
                messageBarVM.showError("Please input SURCHARGE and  SURCHARGE TYPE together");
                return;
            }
            if ((!currentTariffItemTier.additionalUom && currentTariffItemTier.additionalRate)
                || (currentTariffItemTier.additionalUom && !currentTariffItemTier.additionalRate)) {
                messageBarVM.showError("Please input ADDITIONAL UOM and  ADDITIONAL RATE together");
                return;
            }
            if (Number(currentTariffItemTier.rate) > Number(99999999.00) || Number(currentTariffItemTier.rate) < Number(-99999999.00)) {
                messageBarVM.showError("RATE should be range from -99,999,999.00 to 99,999,999.00.");
                return;
            }
            if (Number(currentTariffItemTier.minimum) > Number(99999999.00) || Number(currentTariffItemTier.minimum) < Number(-99999999.00)) {
                messageBarVM.showError("MINIMUM RATE should be range from -99,999,999.00 to 99,999,999.00.");
                return;
            }
            if (Number(currentTariffItemTier.additionalRate) > Number(99999999.00) || Number(currentTariffItemTier.additionalRate) < Number(-99999999.00)) {
                messageBarVM.showError("ADDITIONAL RATE should be range from -99,999,999.00 to 99,999,999.00.");
                return;
            }
            if (Number(currentTariffItemTier.surcharge) > Number(99999999.00) || Number(currentTariffItemTier.surcharge) < Number(0)) {
                messageBarVM.showError("SURCHARGE should be range from 0.00 to 99,999,999.00.");
                return;
            }
        }
        if (isAddTier || isEditTier) {
            standardProposalDtlVM.onSaveClicked();
            standardProposalDtlVM.onTempSaveTariffItemTier(isAddTier, currentSelectItem, currentTier);
            return;
        }
        if (isAddIs || isEditIs) {
            if (currentSelectItem.tierList && currentSelectItem.tierList.length > 1) {
                messageBarVM.showError("Intensive surcharge does not support multiple charge tier.");
                return;
            }
            standardProposalDtlVM.onTempSaveTariffItemIs(isAddIs, currentSelectItem, currentIs);
            return;
        }
        if (currentSelectItem.tierList && currentSelectItem.tierList.length === 0) {
            messageBarVM.showError("Must add one tariff item tier at least.");
            return;
        }

    }, [isAddIs, isEditIs, isAddTier, isEditTier, currentSelectItem, currentTariffItemIs.shiftCode, currentTariffItemIs.percentage, messageBarVM, currentTariffItemTier.minimum, currentTariffItemTier.rate, currentTariffItemTier.surcharge, currentTariffItemTier.surchargeType, currentTariffItemTier.additionalUom, currentTariffItemTier.additionalRate, standardProposalDtlVM, currentTier, currentIs]);


    const memoCycle = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "10px" }}>
            {/* <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentTier?.cycle?.toString() || ''}
                fieldValue={currentTier?.cycle?.toString()}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.CYCLE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'cycle'}
                maxLength={10}
                requiredFieldList={standardProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalDtlVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} /> */}
            <NumberInputComponent
                label={STANDARD_PROPOSAL_CONSTANT.CYCLE}
                maxLength={10}
                fieldName={"cycle"}
                value={currentTier?.cycle ?? ''}
                errorMessage={allFormState ? allFormState["cycle"] ?? "" : ""}
                allowNegative={false}
                disabled={false}
                decimalPlaces={0}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.CYCLE, allFormState, currentTier?.cycle, onNumberFieldChange])

    const memoForEvery = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "10px" }}>
            {/* <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentTier?.forevery?.toString() || ''}
                fieldValue={currentTier?.forevery?.toString()}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.FOR_EVERY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'forevery'}
                maxLength={10}
                requiredFieldList={standardProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalDtlVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} /> */}
            <NumberInputComponent
                label={STANDARD_PROPOSAL_CONSTANT.FOR_EVERY}
                maxLength={10}
                fieldName={"forevery"}
                value={currentTier?.forevery ?? ''}
                errorMessage={allFormState ? allFormState["forevery"] ?? "" : ""}
                allowNegative={false}
                disabled={false}
                decimalPlaces={0}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.FOR_EVERY, allFormState, currentTier?.forevery, onNumberFieldChange])

    const memoUom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "10px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentTier?.uom || ''}
                fieldValue={currentTier?.uom}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.UOM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'uom'}
                maxLength={60}
                options={uomDropdownOption}
                requiredFieldList={standardProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalDtlVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.UOM, allFormState, currentTier?.uom, isSaveClicked, standardProposalDtlVM])

    const memoRate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "10px" }}>
            <NumberInputComponent
                label={STANDARD_PROPOSAL_CONSTANT.RATE}
                maxLength={12}
                fieldName={"rate"}
                value={currentTier?.rate ?? ''}
                errorMessage={allFormState ? allFormState["rate"] ?? "" : ""}
                allowNegative={true}
                disabled={false}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.RATE, allFormState, currentTier?.rate, onNumberFieldChange])

    const memoMinimun = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "10px" }}>
            <NumberInputComponent
                label={STANDARD_PROPOSAL_CONSTANT.MINIMUM}
                maxLength={12}
                fieldName={"minimum"}
                value={currentTier?.minimum ?? ''}
                errorMessage={allFormState ? allFormState["minimum"] ?? "" : ""}
                allowNegative={true}
                disabled={false}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.MINIMUM, allFormState, currentTier?.minimum, onNumberFieldChange])

    const memosurCharge = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "10px" }}>
            <NumberInputComponent
                label={STANDARD_PROPOSAL_CONSTANT.SURCHARGE}
                maxLength={12}
                fieldName={"surcharge"}
                value={currentTier?.surcharge ?? ''}
                errorMessage={allFormState ? allFormState["surcharge"] ?? "" : ""}
                disabled={false}
                allowNegative={true}
                decimalPlaces={2}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.SURCHARGE, allFormState, currentTier?.surcharge, onNumberFieldChange])

    const memoSurChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "10px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentTier?.surchargeType || ''}
                fieldValue={currentTier?.surchargeType}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.SURCHARGE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'surchargeType'}
                maxLength={60}
                options={surChargeTypeDropdownOption}
                requiredFieldList={standardProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalDtlVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.SURCHARGE_TYPE, allFormState, currentTier?.surchargeType, isSaveClicked, standardProposalDtlVM])

    const memoAdditionalRate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "10px" }}>
            <NumberInputComponent
                label={STANDARD_PROPOSAL_CONSTANT.ADDITIONAL_RATE}
                maxLength={12}
                fieldName={"additionalRate"}
                value={currentTier?.additionalRate ?? ''}
                errorMessage={allFormState ? allFormState["additionalRate"] ?? "" : ""}
                disabled={false}
                allowNegative={true}
                decimalPlaces={2}
                optional={true}
                required={false}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.ADDITIONAL_RATE, allFormState, currentTier?.additionalRate, onNumberFieldChange])

    const memoAdditionalUom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "10px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentTier?.additionalUom || ''}
                fieldValue={currentTier?.additionalUom}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.ADDITIONAL_UOM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'additionalUom'}
                maxLength={60}
                options={uomDropdownOption}
                requiredFieldList={standardProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalDtlVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.ADDITIONAL_UOM, allFormState, currentTier?.additionalUom, isSaveClicked, standardProposalDtlVM])

    const memoShiftCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "10px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentIs?.shiftCode || ''}
                fieldValue={currentIs?.shiftCode}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.SHIFT_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'shiftCode'}
                maxLength={60}
                options={standardProposalDtlState.dynamicOptions.shiftCodeDropdownOptions}
                requiredFieldList={standardProposalIsRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalDtlVM.onIsFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.SHIFT_CODE, allFormState, currentIs?.shiftCode, isSaveClicked, standardProposalDtlState.dynamicOptions.shiftCodeDropdownOptions, standardProposalDtlVM])

    const memoPercentage = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "10px" }}>
            <NumberInputComponent
                label={STANDARD_PROPOSAL_CONSTANT.SURCHARGE_P}
                maxLength={10}
                fieldName={"percentage"}
                value={currentIs?.percentage ?? ''}
                errorMessage={allFormState ? allFormState["percentage"] ?? "" : ""}
                disabled={false}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onIsNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.SURCHARGE_P, allFormState, currentIs?.percentage, onIsNumberFieldChange])



    return <div className="side-form-content-left-wrapper" style={{ height: "40vh", maxHeight: "40vh", overflow: "visible", padding: "5px" }}>

        <div className={'flex-row'}>
            <div className={'flex-row-item flex-row-item-full-width'}>
                <Sidebarheader>
                    <SidebarTitle>
                        {isAddTier && "Add " + STANDARD_PROPOSAL_CONSTANT.TIER_VALUE}
                        {isAddIs && "Add " + STANDARD_PROPOSAL_CONSTANT.IS_VALUE}
                    </SidebarTitle>
                    <SidebarActionCross>
                        <IconButton
                            fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={handleCancel} />
                        <IconButton
                            fileName="Icon-tick" size="medium" toolTipText='Save' toolTipArrow={false} onClick={handleSave} />
                    </SidebarActionCross>
                </Sidebarheader>
            </div>
        </div>

        <div className={'add-edit-form'} style={{ height: '30vh', maxHeight: '30vh', overflow: 'visible', zIndex: '100' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    {(isAddTier || isEditTier) &&
                        <><CriteriaItemContainer>
                            {memoCycle}
                            {memoForEvery}
                            {memoUom}
                        </CriteriaItemContainer>
                            <CriteriaItemContainer>
                                {memoRate}
                                {memoMinimun}
                                {memosurCharge}
                            </CriteriaItemContainer>
                            <CriteriaItemContainer>
                                {memoSurChargeType}
                                {memoAdditionalRate}
                                {memoAdditionalUom}
                            </CriteriaItemContainer>
                        </>}
                    {(isAddIs || isEditIs) &&
                        <>
                            <CriteriaItemContainer>
                                {memoShiftCode}
                                {memoPercentage}
                            </CriteriaItemContainer>
                        </>}
                </div>
            </div>
        </div>
    </div>;
}

export default memo(AddTariffItemIsEditPanel)